module.exports = require('mn-utils/browser/withStateProvider')(require('react'));
